import axios from 'axios';
import { HTTP } from '@/http/config'; 
import authHeader from '@/services/auth.header';
//import ILogin from '@/interfaces/ILogin';
const API_URL = HTTP.api_url;

class AuthService {
  async login(user):Promise<[]> {
   // console.log(user)
    return await axios    
      .post(API_URL+ 'auth/' + 'login', {
        email: user.email,
        password: user.password
      })
      .then(response => {        
       // if (response.data.access_token) {
        // console.log(access_token) response.data.data.access_token
         const access_token = (typeof response.data.access_token !== 'undefined')
        ?response.data.access_token:null
        if (access_token) {   
          localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
      }).catch(error => {
        const dataError = JSON.parse(JSON.stringify(error.response.data))
        console.log(dataError)
        return dataError
      });
  }

 async logout():Promise<any> {
    // return axios
    // .post(API_URL+'logout',{headers: authHeader()})
    // .then(response => {              
    //   console.log('Usuario removido del localstore.');
        localStorage.removeItem('user');      
    //   return response.data;
    // }).catch(error => {
    //   const dataError = JSON.parse(JSON.stringify(error.response.data))
    //   console.log(dataError)
    //   return dataError
    // });
  }

  register(user: { username?: string; email?: string; password?: string; }) {
    return axios.post(API_URL + 'auth/' + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }
}

export default new AuthService();